// extracted by mini-css-extract-plugin
export default {"StickyBlock":"bfh_a bih_bj"};